export const NUTRITIONIST_SPECIALITIES:Record<string,Record<string,string>> =  {
    english:{
        medical:'Medical',
        certified:'Certified'
    },
    arabic:{
        medical:'طبی',
        certified:'معتمد'
    }
}